"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Alert", {
    enumerable: true,
    get: function() {
        return Alert;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _ri = require("react-icons/ri");
const _Theme = require("../../contexts/Theme");
const _AdminButton = require("../Button/AdminButton");
const _Button = require("../Button/Button");
const _Text = require("../Text/Text");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const Alert = (param)=>{
    let { message, description, variant = "neutral", size = "normal", icon, onClose, primaryAction, secondaryAction, className, centerIcon } = param;
    const { colors, isAdmin } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        onClick: (e)=>{
            e.stopPropagation();
        },
        role: "alert",
        "data-escape-focus-trap": true,
        className: _style.default.dynamic([
            [
                "fc36b330ac97e0d9",
                [
                    colors.grayscale[80],
                    colors.blue[60],
                    colors.status.danger.primary,
                    colors.grayscale[5],
                    centerIcon === true ? "center" : "auto"
                ]
            ]
        ]) + " " + "alert ".concat("alert--".concat(variant, " alert--").concat(size, " ").concat(className !== null && className !== void 0 ? className : ""))
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "fc36b330ac97e0d9",
                [
                    colors.grayscale[80],
                    colors.blue[60],
                    colors.status.danger.primary,
                    colors.grayscale[5],
                    centerIcon === true ? "center" : "auto"
                ]
            ]
        ]) + " " + "left-group"
    }, icon != null && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "fc36b330ac97e0d9",
                [
                    colors.grayscale[80],
                    colors.blue[60],
                    colors.status.danger.primary,
                    colors.grayscale[5],
                    centerIcon === true ? "center" : "auto"
                ]
            ]
        ]) + " " + "icon-container"
    }, icon), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "fc36b330ac97e0d9",
                [
                    colors.grayscale[80],
                    colors.blue[60],
                    colors.status.danger.primary,
                    colors.grayscale[5],
                    centerIcon === true ? "center" : "auto"
                ]
            ]
        ]) + " " + "left-group-message"
    }, typeof message === "string" ? /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "text",
        size: "small",
        component: "span"
    }, message) : message, description != null && /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "text",
        size: "small",
        style: {
            color: colors.grayscale[60]
        },
        component: "span"
    }, description))), (secondaryAction != null || primaryAction != null || onClose != null) && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "fc36b330ac97e0d9",
                [
                    colors.grayscale[80],
                    colors.blue[60],
                    colors.status.danger.primary,
                    colors.grayscale[5],
                    centerIcon === true ? "center" : "auto"
                ]
            ]
        ]) + " " + "right-group"
    }, secondaryAction != null && isAdmin && /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        variant: "outline",
        size: "sm",
        inverted: true,
        onClick: secondaryAction.onClick
    }, secondaryAction.title), secondaryAction != null && !isAdmin && /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        variant: "secondary",
        color: "#fff",
        size: "sm",
        onClick: secondaryAction.onClick
    }, secondaryAction.title), primaryAction != null && isAdmin && /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        variant: "secondary",
        size: "sm",
        inverted: true,
        onClick: primaryAction.onClick
    }, primaryAction.title), primaryAction != null && !isAdmin && /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        variant: "primary",
        color: "#fff",
        size: "sm",
        onClick: primaryAction.onClick
    }, primaryAction.title), onClose != null && size !== "large" && /*#__PURE__*/ _react.default.createElement("div", {
        role: "button",
        "aria-label": "close",
        onClick: onClose,
        className: _style.default.dynamic([
            [
                "fc36b330ac97e0d9",
                [
                    colors.grayscale[80],
                    colors.blue[60],
                    colors.status.danger.primary,
                    colors.grayscale[5],
                    centerIcon === true ? "center" : "auto"
                ]
            ]
        ]) + " " + "close-container"
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiCloseLine, {
        size: 24
    })))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "fc36b330ac97e0d9",
        dynamic: [
            colors.grayscale[80],
            colors.blue[60],
            colors.status.danger.primary,
            colors.grayscale[5],
            centerIcon === true ? "center" : "auto"
        ]
    }, ".alert.__jsx-style-dynamic-selector{color:#fff;padding:.75rem 1rem .75rem 1.5rem;-webkit-border-radius:.5rem;-moz-border-radius:.5rem;border-radius:.5rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:1.5rem;height:3.5rem}.alert.__jsx-style-dynamic-selector span{font-weight:500;line-height:1.5rem}.alert--large.__jsx-style-dynamic-selector{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;height:unset;padding-left:1rem}.alert--large.__jsx-style-dynamic-selector span{line-height:1.25rem}.alert--large.__jsx-style-dynamic-selector .left-group.__jsx-style-dynamic-selector{-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start}.alert--neutral.__jsx-style-dynamic-selector{background-color:".concat(colors.grayscale[80], "}.alert--positive.__jsx-style-dynamic-selector{background-color:").concat(colors.blue[60], "}.alert--negative.__jsx-style-dynamic-selector{background-color:").concat(colors.status.danger.primary, "}.alert--gray.__jsx-style-dynamic-selector{background-color:").concat(colors.grayscale[5], ";color:#000}.alert--gray.__jsx-style-dynamic-selector span{font-weight:400}.icon-container.__jsx-style-dynamic-selector{-webkit-align-self:").concat(centerIcon === true ? "center" : "auto", ";-ms-flex-item-align:").concat(centerIcon === true ? "center" : "auto", ";align-self:").concat(centerIcon === true ? "center" : "auto", "}.icon-container.__jsx-style-dynamic-selector svg{display:block}.right-group.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-left:auto;gap:.5rem}.left-group.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:.5rem}.left-group-message.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:5px}.close-container.__jsx-style-dynamic-selector{cursor:pointer}")));
};

//# sourceMappingURL=Alert.js.map